import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { deleteListing } from "../../api/listingApi";
import { Button } from "../ui/button";
import { Loader2, Trash2 } from "lucide-react";

export const DeleteListing = ({ listingId }) => {
  const navigate = useNavigate();
  const [confirming, setConfirming] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState("");

  const handleDelete = async () => {
    setIsDeleting(true);
    setError("");

    try {
      const token = localStorage.getItem("token");
      const response = await deleteListing(listingId, token);
      console.log("Delete response", response);

      if (!response.success) {
        setError(response.message || "Failed to delete listing.");
        setIsDeleting(false);
        return;
      }

      // Navigate back to browse page
      navigate("/browse", {
        state: { message: "Listing deleted successfully!" },
      });
    } catch (error) {
      console.error(error);
      setError("An error occurred while deleting the listing.");
      setIsDeleting(false);
    }
  };

  if (!confirming) {
    return (
      <div className="flex items-center justify-end space-x-4 pt-6 border-t border-gray-200">
        <Button
          variant="destructive"
          onClick={() => setConfirming(true)}
          className="gap-2"
        >
          <Trash2 className="w-4 h-4" />
          Delete Listing
        </Button>
      </div>
    );
  }

 return (
  <div className="flex flex-col items-end justify-end pt-6 border-t border-gray-200 gap-3">
    <p className="text-sm text-red-600 text-right">
      Are you sure you want to delete this listing? This cannot be undone.
    </p>

    <div className="flex gap-2">
      <Button
        variant="destructive"
        onClick={handleDelete}
        disabled={isDeleting}
      >
        {isDeleting ? (
          <>
            <Loader2 className="w-4 h-4 animate-spin mr-2" />
            Deleting...
          </>
        ) : (
          "Yes, Delete"
        )}
      </Button>
      <Button variant="outline" onClick={() => setConfirming(false)}>
        Cancel
      </Button>
    </div>

    {error && <p className="text-sm text-red-500 text-right">{error}</p>}
  </div>
);

};
